// src/components/store/sections/newsletter/DynamicNewsletterVariant.tsx
"use client";

import React, { useState } from "react";
import { Mail, Sparkles, ArrowRight, CheckCircle2, Gift } from "lucide-react";

export default function DynamicNewsletterVariant({
  variantNumber,
  archKey,
  archLabel,
  palName,
  grad,
  lightBg,
  textCol,
  borderCol,
  subdomain = "nextlook",
}: any) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await fetch(`http://${subdomain}.localhost:8000/api/v1/stores/newsletter/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      setStatus("success");
      setEmail("");
    } catch {
      setStatus("success");
      setEmail("");
    }
  };

  const isDark = archKey === "cyber_console" || palName === "SlateGold";

  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 py-6 select-none font-sans">
      <div
        className={`relative rounded-[34px] overflow-hidden border-2 ${borderCol} ${
          archKey === "gradient_banner"
            ? `bg-gradient-to-r ${grad} text-white`
            : isDark
            ? "bg-slate-950 text-white"
            : `${lightBg} text-slate-900`
        } p-6 sm:p-10 shadow-xl flex flex-col md:flex-row items-center justify-between gap-6`}
      >
        <div className="space-y-2.5 max-w-lg text-left">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/90 text-slate-900 text-[10px] font-black uppercase tracking-widest shadow-2xs">
            <Gift className="w-3.5 h-3.5 text-rose-500" />
            <span>Variant {variantNumber}: {archLabel} ({palName})</span>
          </span>
          <h2 className="text-2xl sm:text-3xl font-black tracking-tight leading-tight">
            Unlock 25% Off Your First Order + VIP Flash Alerts
          </h2>
          <p className={`text-xs sm:text-sm ${archKey === "gradient_banner" || isDark ? "text-white/80" : "text-slate-600"}`}>
            Join our insider club for early access to new drops, private vouchers, and weekly curated picks.
          </p>
        </div>

        <div className="w-full md:w-auto min-w-[290px] sm:min-w-[350px]">
          {status === "success" ? (
            <div className="p-4 rounded-2xl bg-emerald-500 text-white font-black text-xs flex items-center justify-center gap-2 shadow-md">
              <CheckCircle2 className="w-4 h-4" />
              <span>ধন্যবাদ! আপনি সফলভাবে সাবস্ক্রাইব করেছেন।</span>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="flex items-center gap-2 p-2 rounded-2xl bg-white border-2 border-slate-200 shadow-lg"
            >
              <Mail className="w-4 h-4 text-slate-400 ml-2 shrink-0" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address..."
                required
                className="flex-1 text-xs sm:text-sm text-slate-800 bg-transparent outline-none px-1"
              />
              <button
                type="submit"
                className={`px-5 py-2.5 rounded-xl bg-gradient-to-r ${grad} text-white font-black text-xs uppercase tracking-wider shadow-sm cursor-pointer active:scale-95 transition-all flex items-center gap-1 shrink-0`}
              >
                <span>Join</span>
                <ArrowRight className="w-3.5 h-3.5" />
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
